




















import { Component, Vue } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import CONFIG from "@/common/config";
import fetch from "@/common/api/fetch";
import getUrlParam from '@/common/utils/getUrlParam';
import getActivityType from '@/common/utils/getActivityType';

import { AxiosPromiseData } from "@/common/interface";

@Component
export default class ActivityLink extends Vue {

  @Getter("documentTitle")
  documentTitle!: string;
  @Getter("showWantDo")
  showWantDo!: boolean;

  @Action("changeShowIWantDo")
  changeShowIWantDo!: Function;

  getUrlParam: Function = getUrlParam;

  mounted() {
    if (getUrlParam("type") === "share") {
      this.getShowSetting();
    }
  }

  getShowSetting() {
    const param = {
      broadcastId: getUrlParam("broadcastId")
    };
    fetch
      .post("c/xm/show/checkXmShowSetting", param)
      .then((res: AxiosPromiseData) => {
        this.changeShowIWantDo(res.data);
      });
  }

  handleClickXmx(): void {
    if (!window.WeixinJSBridge || !window.WeixinJSBridge.invoke) {
      document.addEventListener("WeixinJSBridgeReady", this.ready, false);
    } else {
      this.ready();
    }
    try {
      if (window.__wxjs_environment === "miniprogram") {
        window.TDAPP.onEvent("点击【小麦秀提供技术】", "小程序", {
          活动名称: this.documentTitle,
          活动类型: CONFIG.templateMap[getActivityType()]
        });
      } else {
        window.TDAPP.onEvent("点击【小麦秀提供技术】", "H5", {
          活动名称: this.documentTitle,
          活动类型: CONFIG.templateMap[getActivityType()]
        });
      }
    } catch (error) {
      throw new Error(error);
    }
  }

  ready(): void {
    if (window.__wxjs_environment === "miniprogram") {
      window.wx.miniProgram.switchTab({
        url: "/pages/index/main"
      });
    } else {
      window.location.replace(
        "https://mp.weixin.qq.com/s/xFBKURaVWpoiu5ioJKGh1g"
      );
    }
  }
}
